<ng-template #questionnairesTemplates>
  <redactor-inserts-outlet
    [componentId]="KnownInserts.Questionaires"
    [hasBackAction]="hasBackAction()"
    (back)="dropdown.prevTemplate()"
    (settings)="goToSettings($event)"
    (closeDropdown)="closeDropdown()"
    (insertLink)="insertLink.emit($event)"
  />
</ng-template>
<ng-template #emailTemplates>
  <redactor-inserts-outlet
    [componentId]="KnownInserts.EmailTemplates"
    [insideTemplate]="emailTemplateInsideTemplate()"
    [hasBackAction]="hasBackAction()"
    [kind]="'email-templates'"
    (back)="dropdown.prevTemplate()"
    (settings)="goToSettings($event)"
    (closeDropdown)="closeDropdown()"
    (emailTemplateChoose)="emailTemplateChoose.emit($event); closeDropdown()"
    (saveAsTemplate)="saveAsTemplate.emit(); closeDropdown()"
  />
</ng-template>
<ng-template #eventInvitationTemplates>
  <redactor-inserts-outlet
    [componentId]="KnownInserts.EmailTemplates"
    [insideTemplate]="emailTemplateInsideTemplate()"
    [hasBackAction]="hasBackAction()"
    [kind]="'event-invitation-templates'"
    (back)="dropdown.prevTemplate()"
    (settings)="goToSettings($event)"
    (closeDropdown)="closeDropdown()"
    (emailTemplateChoose)="emailTemplateChoose.emit($event); closeDropdown()"
    (saveAsTemplate)="saveAsTemplate.emit(); closeDropdown()"
  />
</ng-template>
<ng-template #schedules>
  <redactor-inserts-outlet
    [componentId]="KnownInserts.Scheduler"
    [hasBackAction]="hasBackAction()"
    (back)="dropdown.prevTemplate()"
    (settings)="goToSettings($event)"
    (closeDropdown)="closeDropdown()"
    (insertLink)="insertLink.emit($event)"
  />
</ng-template>
<ng-template #gdprLinks>
  <redactor-inserts-outlet
    [componentId]="KnownInserts.Gdpr"
    [hasBackAction]="hasBackAction()"
    (back)="dropdown.prevTemplate()"
    (settings)="goToSettings($event)"
    (closeDropdown)="closeDropdown()"
    (insertLink)="insertLink.emit($event)"
  />
</ng-template>
<ng-template #gdprLinksWithoutConsent>
  <redactor-inserts-outlet
    [componentId]="KnownInserts.Gdpr"
    [hasBackAction]="hasBackAction()"
    [isConsentRequestShow]="false"
    (back)="dropdown.prevTemplate()"
    (settings)="goToSettings($event)"
    (closeDropdown)="closeDropdown()"
    (insertLink)="insertLink.emit($event)"
  />
</ng-template>
<ng-template #integrationsKununu>
  <redactor-inserts-outlet
    [componentId]="KnownInserts.Kununu"
    [hasBackAction]="hasBackAction()"
    (back)="dropdown.prevTemplate()"
    (closeDropdown)="closeDropdown()"
    (insertLink)="insertLink.emit($event)"
  />
</ng-template>

<rt-dropdown
  #dropdown
  [isForcedChangeDetection]="false"
  rtScrollable
  (click)="$event.preventDefault()"
>
  <rt-dropdown-header [fullWidthTitle]="true">
    {{ 'app.redactor_inserts.dropdown.header' | translate }}
  </rt-dropdown-header>
  @for (insert of inserts(); track insert) {
    <rt-redactor-inserts-dropdown-item
      [iconName]="RedactorInsertStepTemplateMap[insert].icon"
      [heading]="RedactorInsertStepTemplateMap[insert].heading"
      [subheading]="RedactorInsertStepTemplateMap[insert].subheading"
      [targetFor]="RedactorInsertStepTemplateMap[insert].template"
      [featureGuard]="RedactorInsertStepTemplateMap[insert].featureGuard!"
      [selected]="isSelected(insert)"
    />
  }
</rt-dropdown>
